import axios from 'axios';
import API_BASE_URL from './api';

const API = `${API_BASE_URL}/api/messaging`;

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

export const listConversations = async (token) => {
  const res = await axios.get(`${API}/conversations`, { headers: authHeaders(token) });
  return res.data.conversations;
};

export const createConversation = async (participantEmails, token, type = 'dm', title = null) => {
  const res = await axios.post(`${API}/conversations`, { participant_emails: participantEmails, type, title }, { headers: authHeaders(token) });
  return res.data.conversation;
};

export const createSupportConversation = async (token) => {
  const res = await axios.post(`${API}/conversations/support`, {}, { headers: authHeaders(token) });
  return res.data.conversation;
};

export const getMessages = async (conversationId, token, before = null) => {
  const params = before ? { before } : {};
  const res = await axios.get(`${API}/conversations/${conversationId}/messages`, { headers: authHeaders(token), params });
  return res.data.messages;
};

export const sendTextMessage = async (conversationId, content, token) => {
  const res = await axios.post(`${API}/conversations/${conversationId}/messages`, { content }, { headers: authHeaders(token) });
  return res.data.message;
};

export const sendVoiceMessage = async (conversationId, audioBlob, token) => {
  const form = new FormData();
  form.append('file', audioBlob, `voice-${Date.now()}.webm`);
  const res = await axios.post(`${API}/conversations/${conversationId}/messages/voice`, form, {
    headers: { ...authHeaders(token), 'Content-Type': 'multipart/form-data' },
  });
  return res.data.message;
};

export const markConversationRead = async (conversationId, token) => {
  await axios.post(`${API}/conversations/${conversationId}/read`, {}, { headers: authHeaders(token) });
};

export const blockUser = async (targetEmail, token) => {
  const form = new FormData();
  form.append('target_email', targetEmail);
  await axios.post(`${API}/block`, form, { headers: authHeaders(token) });
};

export const unblockUser = async (targetEmail, token) => {
  await axios.delete(`${API}/block/${encodeURIComponent(targetEmail)}`, { headers: authHeaders(token) });
};

export const listBlocked = async (token) => {
  const res = await axios.get(`${API}/blocked`, { headers: authHeaders(token) });
  return res.data.blocked;
};

export const reportContent = async ({ targetEmail, messageId, reason }, token) => {
  await axios.post(`${API}/report`, { target_email: targetEmail, message_id: messageId, reason }, { headers: authHeaders(token) });
};

// Connexion WebSocket temps réel. Retourne l'instance WebSocket ; l'appelant gère onmessage/onclose.
export const connectMessagingSocket = (token) => {
  const wsBase = API_BASE_URL.replace(/^http/, 'ws');
  return new WebSocket(`${wsBase}/api/messaging/ws?token=${encodeURIComponent(token)}`);
};
